export default {
  labels: {
    radius: 'Raggio',
  },
};
